import Marionette from "../../shared/marionette-mustache";
import { BrowsePanelView } from "../../old-browse/views/browse-panel";
import { BrowsePanelModel } from "../../old-browse/models/browse-panel";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    childView : BrowsePanelView
})
export class BrowsePanelsCollection extends Marionette.CollectionView<BrowsePanelModel, BrowsePanelView> {
    constructor(options?: Marionette.CollectionViewOptions<BrowsePanelModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/collections/browse-panels.ts